export const scrollTop = () => {
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToHash = (hash, behavior = "smooth") => {
  const id = (hash || "").replace(/^#/, "");
  if (!id) {
    window.scrollTo({ top: 0, behavior });
    return;
  }

  const scrollTarget = (el) => {
    el.scrollIntoView({ behavior, block: "start" });
  };

  const attempt = (triesLeft = 12) => {
    const el = document.getElementById(id);
    if (el) {
      scrollTarget(el);
      return;
    }
    if (triesLeft > 0) {
      window.setTimeout(() => attempt(triesLeft - 1), 50);
    }
  };

  attempt();
};
export async function copyTextToClipboard(text, callbackAction) {
  const value = text == null ? "" : String(text).trim();
  if (!value) {
    callbackAction?.(false);
    return false;
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      callbackAction?.(true);
      return true;
    }
  } catch (error) {
    // Fall back to execCommand when Clipboard API is blocked.
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (copied) {
      callbackAction?.(true);
      return true;
    }
  } catch (error) {
    // Ignore and report failure below.
  }

  callbackAction?.(false);
  return false;
}
